import { useQuery } from "@apollo/client";
import { ProductPriceQuery } from "../queries/productQueries";

export type ProductPriceInfoQueryResultType = {
  product: {
    _id: string;
    simulatedPrice?: {
      amount: number;
      currency: string;
    };
    publicare?: {
      clientMigelConformity?: string;
      institutionalMigelConformity?: string;
    };
  };
};

const useProductPriceInfo = ({
  productId,
  configuration,
  shouldUseInstitutionalMigelConformity = false,
}: {
  productId: string;
  configuration: Record<string, any>;
  shouldUseInstitutionalMigelConformity?: boolean;
}) => {
  const {
    data: { product } = {},
    previousData: { product: previousProduct } = {},
    ...rest
  } = useQuery<ProductPriceInfoQueryResultType>(ProductPriceQuery, {
    notifyOnNetworkStatusChange: true,
    returnPartialData: true,
    variables: {
      productId,
      configuration,
    },
    skip: !productId,
  });

  const migelConformity = shouldUseInstitutionalMigelConformity
    ? product?.publicare?.institutionalMigelConformity ||
      previousProduct?.publicare?.institutionalMigelConformity
    : product?.publicare?.clientMigelConformity ||
      previousProduct?.publicare?.clientMigelConformity;

  return {
    price: product?.simulatedPrice || previousProduct?.simulatedPrice,
    migelConformity,
    ...rest,
  };
};

export default useProductPriceInfo;
